import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "public-booking-view" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "booking-form-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicAppointmentFlow = _resolveComponent("DynamicAppointmentFlow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("header", { class: "booking-intro" }, [
        _createElementVNode("h1", null, "Beauty Academy Enquiry – Attractive Salon Gondia"),
        _createElementVNode("p", null, "Ask about hands-on beauty and salon training in a live salon environment.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DynamicAppointmentFlow, {
          "show-price": false,
          "flow-type": "academy-enquiry"
        })
      ])
    ])
  ]))
}